// extracted by mini-css-extract-plugin
export var banner = "_1y-0";
export var icon = "_1y-1";
export var message = "_1y-2";